// Magyarország
export default {
	status: {
		All: "Összes",
		Pending: "Függőben lévő",
		Frozen: "Fagyasztott",
		Completed: "Befejezett",
		Undone: "Nem elvégzett"
	},
	TotalAmount: "Teljes összeg",
	Profit: "Profit",
	Expire: "Lejár"
};
